import { render, staticRenderFns } from "./StockValuationReportWithCost.vue?vue&type=template&id=386e24b0&"
import script from "./StockValuationReportWithCost.vue?vue&type=script&lang=js&"
export * from "./StockValuationReportWithCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports